import React from 'react';
import { Link } from 'react-router-dom';
import { TESTIMONIAL_BY_APP } from './Testimonials';
import { IconArrowRight, IconCheck, IconExternal } from './Icons';
import './CaseStudy.css';

// Featured case study. Qualitative only — no invented metrics.
const STUDY = {
  client: 'Kevin Adams',
  role: 'Mayor, Village of Horseheads, NY',
  url: 'https://kevindadams.com/',
  displayUrl: 'kevindadams.com',
  eyebrow: 'Featured Case Study',
  title: 'A campaign-ready website for the Office of the Mayor',
  before: [
    'No dedicated, modern home online heading into a re-election cycle',
    'Bio, qualifications, and vision scattered across posts and word of mouth',
    'No reliable way for residents and supporters to reach the office or get involved',
  ],
  after: [
    'Polished bio, qualifications, and vision pages the office fully controls',
    'Animated, mobile-first layout built for door-to-door sharing',
    'A contact funnel that routes resident & supporter messages straight to the office',
    'Editable content structure so updates go live in minutes, not weeks',
  ],
  result:
    'A fast, professional, phone-friendly presence the office owns — and a contact funnel that turns visitors into real conversations.',
};

const CaseStudy = () => {
  const quote = TESTIMONIAL_BY_APP['adams'];

  return (
    <section className="section section--deep case-study-section" id="adams-case-study">
      <div className="container">
        <div className="section-head">
          <p className="eyebrow">{STUDY.eyebrow}</p>
          <h2 className="section-title reveal reveal-up">{STUDY.title}</h2>
          <p className="case-study-client reveal reveal-fade" style={{ '--reveal-delay': '0.1s' }}>
            <span>{STUDY.client}</span>
            <span className="case-study-client-sep" aria-hidden="true">/</span>
            <span>{STUDY.role}</span>
            <span className="case-study-client-sep" aria-hidden="true">/</span>
            <a href={STUDY.url} target="_blank" rel="noopener noreferrer">
              {STUDY.displayUrl}
              <IconExternal />
            </a>
          </p>
        </div>

        <div className="case-study-grid">
          <div className="case-study-col reveal reveal-up">
            <span className="case-study-label">Before</span>
            <h3 className="case-study-col-title">The challenge</h3>
            <ul className="case-study-list">
              {STUDY.before.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="case-study-seam" aria-hidden="true">
            <span className="case-study-seam-line" />
            <span className="case-study-seam-mark">
              <IconArrowRight />
            </span>
            <span className="case-study-seam-line" />
          </div>

          <div
            className="case-study-col case-study-col--after reveal reveal-up"
            style={{ '--reveal-delay': '0.1s' }}
          >
            <span className="case-study-label case-study-label--after">After</span>
            <h3 className="case-study-col-title">What we built</h3>
            <ul className="case-study-list case-study-list--check">
              {STUDY.after.map((item) => (
                <li key={item}>
                  <IconCheck />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="case-study-result reveal reveal-up">
          <span className="case-study-result-label">The result</span>
          <p>{STUDY.result}</p>
        </div>

        {quote && (
          <figure className="case-study-quote reveal reveal-scale">
            <blockquote>&ldquo;{quote.quote}&rdquo;</blockquote>
            <figcaption>
              <span className="case-study-quote-name">{quote.author}</span>
              <span className="case-study-quote-role">{quote.role}</span>
            </figcaption>
          </figure>
        )}

        <div className="case-study-cta reveal reveal-up">
          <Link
            to={`/contact?reason=quote&topic=${encodeURIComponent('Campaign or elected-official website like Kevin Adams')}`}
            className="btn btn--primary"
          >
            Get a site like this <span className="btn-arrow">→</span>
          </Link>
          <a
            href={STUDY.url}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--ghost"
          >
            Visit {STUDY.displayUrl}
            <IconExternal />
          </a>
        </div>
      </div>
    </section>
  );
};

export default CaseStudy;
